import analyticsSlice from './analyticsSlice';

export const {
  userLogin,
  returningUserLogin,
  alternateProviderDirectoryRedirected,
  changedNetworkSlug,
  searchFormSubmitted,
  topSearch,
  searchThisArea,
  appliedFiltersSearch,
  directionsOpenedFromResultCard,
  directionsOpenedFromProfile,
  chatModalOpened,
  directionsClickFromChatProfile,
  phoneClickFromChatProfile,
  phoneClickFromProfile,
  phoneClickFromResultCard,
  faxClickFromProfile,
  faxClickFromResultCard,
  logReferral,
  phoneClickFromNeedHelpButton,
  phoneClickFromCompareModal,
  addressClickFromCompareModal,
  scheduleClickFromNeedHelpButton,
  promotionResultView,
  promotionProfileView,
  landingPagePromotionClick,
  serviceResultView,
  serviceProfileView,
  compareView,
  compareProfileView,
  mapMarkerView,
  directionsClickFromPromotionProfile,
  websiteClickFromPromotionProfile,
  accessAppLinkFromPromotionProfile,
  accessChatLinkFromPromotionProfile,
  accessEmailFromPromotionProfile,
  accessPDFfromPromotionProfile,
  phoneClickFromPromotionProfile,
  profileView,
  chatProfileView,
  chatExternalLinkClick,
  getStartedClickFromPromotionProfile,
  printProfile,
  printCompareTable,
  printShareCompareTable,
  sharedProfile,
  providerServiceCostView,
  alternateSearchRecommended,
  zipcodeNetworkSelectionSubmitted,
  copyTextCompareTable,
  copyTextProfilePage,
  costEstimatorRedirect,
  howToVideoClick,
  featuredActionClick,
  cignaCostLinkClicked,
  checkRequestClicked,
  pageView,
  aiSpecialtySearch,
  appendixSpecialtySearch,
} = analyticsSlice.actions;
